import React from 'react';
import { connect } from 'react-redux';
import ve_logo from './cloud_logo.png';
import Logo from './Logo';
import '../../../App.css';

const Header = props => {
  const {user} = props

  return(
    <div style={styles.container}>
      <Logo source={ve_logo} />
      <div>User: {user.sName}</div>
    </div>
  )
}

const mapStateToProps = state => {
  const {user} = state.auth
  return {user}
}
export default connect(mapStateToProps)(Header);

const styles = {
  container: {
    height: '10vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 20px',
    marginRight: '15vw',
    color: 'white',
    fontSize: '1.5vmin',
    fontWeight: 'bold',
  }
}